import React from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import "./cta.css";

const CTAButtonMob = ({ to, text, buttonText, icon: Icon, external, tabText }) => {
  if (external === "true") {
    return (
      <a
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        className="cta-button-fullwidth cta-button-mob"
      >
          {Icon && <Icon className="cta-icon" />}
        <div className="cta-content">
          <h3 className="cta-text">{text}</h3>
        </div>
        {tabText && (
          <div className="cta-tab">
            <Flame />
            {tabText}
          </div>
        )}
        <div className="cta-button">{buttonText}</div>
      </a>
    );
  }

  return (
    <Link to={to} className="cta-button-fullwidth cta-button-mob">
      <div className="cta-content">
        <h3 className="cta-text">{text}</h3>
        {Icon && <Icon className="cta-icon" />}
      </div>
      {tabText && (
        <div className="cta-tab">
          <Flame />
          {tabText}
        </div>
      )}
      <div className="cta-button">{buttonText}</div>
    </Link>
  );
};

export default CTAButtonMob;

